<script lang="ts">
import { OpportunitiesI3pService } from '~/services/opportunities.i3p.service'
import OpportunitiesI3p from '~/components/I3pComponent/opportunities/OpportunitiesI3p.vue'
import { BaseRoutesEnum } from '~/enum/BaseRoutes.enum'
import { useConfigStore } from '~/store'

export default {
    name: 'ToutesLesOpportunites',
    components: {
        OpportunitiesI3p,
    },
    setup() {
        useHead({
            title: 'Toutes les opportunitiés',
            meta: [
                { name: 'description', content: 'Toutes les opportunitiés' },
            ],
        })
        definePageMeta({
            middleware: ['auth'],
        })
    },
    data() {
        const configStore = useConfigStore()
        return {
            configStore,
            baseUrl: BaseRoutesEnum.allOpportunities,
            opportunityI3pService: new OpportunitiesI3pService()
                .setInitialQuery({ display_all_organizations: true })
                .setHiddenFilters(['my_organization_id']),
        }
    },
    computed: {
        isApplicationServiceReady(): boolean {
            return !!this.configStore?.currentConfig?.app_info
        },
    },
}
</script>

<template>
    <OpportunitiesI3p v-if="isApplicationServiceReady" :i3p-service="opportunityI3pService" :base-url />
</template>
